<script lang="ts" setup>
import { useDateTime } from "@/composables";
import { computed, ref } from "vue";
import { useAppStore } from "@/store/app.store";
import type { TruckDto } from "@/api/trucks/dto/truck.dto";
import TruckStatusChip from "@/components/chips/TruckStatusChip.vue";
import type { Anchor } from "vuetify/framework";
import TruckRoutesPopover from "@/components/truck/TruckRoutesPopover.vue";

const { dateTZ } = useDateTime();
const appStore = useAppStore();

const props = withDefaults(
  defineProps<{
    truck: TruckDto;
    light?: boolean;
    menuLocation?: Anchor;
  }>(),
  {
    light: false,
    menuLocation: "top start",
  },
);

const emits = defineEmits<{
  (e: "click"): void;
}>();

const isMenuActive = ref<boolean>(false);

const changedTime = computed(() => {
  if (!props.truck.statusChangedAt || !appStore.dispatcher?.timezone) {
    return "";
  }

  return dateTZ(props.truck.statusChangedAt, appStore.dispatcher.timezone);
});
</script>

<template>
  <truck-routes-popover
    v-model="isMenuActive"
    :disabled="!truck?.statusChangedAt || !truck?.statusChangedBy"
    :truck-id="truck.id"
    open-on-hover
  >
    <template #activator="popoverProps">
      <truck-status-chip
        :light="props.light"
        :truck="props.truck"
        v-bind="{ ...$attrs, ...popoverProps }"
        @click="emits('click')"
      />
    </template>

    <template #header>
      <div class="mb-5">
        <div>
          Change time: <span class="font-weight-500">{{ changedTime }}</span>
        </div>
        <div>
          Changed by: <span class="font-weight-500 text-primary">{{ truck.statusChangedBy }}</span>
        </div>
      </div>
    </template>
  </truck-routes-popover>
</template>

<style lang="scss" scoped>
.status-label {
  white-space: nowrap;
  display: inline-block;
  line-height: 16px !important;
  font-size: 11px;
}
</style>
